import styles from './styles.module.css';
import React, { FC } from 'react';
import * as icons from '../ChallengeCard/assets';
import { Tooltip } from '@clearcover/atlas';
import { GetChallengesResponseType } from 'Rewards/services/endpoints/GetChallenges/types';

const EmptyBadge: FC = () => {
  return <div className={styles.emptyBadge} />;
};

const Achievement: FC<{
  title: string;
  tier: {
    name: string;
    badgeIcon: string;
  };
}> = ({ title, tier }) => (
  <Tooltip key={tier.name} tooltip={`${title} - ${tier.name}`} position="top">
    <img
      src={icons[tier.badgeIcon as keyof typeof icons]}
      className={styles.achievementImage}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null; // prevents looping
        currentTarget.src = icons['Fallback'];
      }}
      alt={`${tier.name} badge`}
    />
  </Tooltip>
);

export const AchievementsCard: FC<{
  achievements: GetChallengesResponseType['achievements'];
}> = ({ achievements }) => {
  let topBadges: Array<React.JSX.Element> = [];
  let bottomBadges: Array<React.JSX.Element> = [];
  achievements
    .filter(achievement => achievement.tier !== null)
    .slice(0, 6)
    .forEach(achievement =>
      topBadges.push(<Achievement {...achievement} tier={achievement.tier!} />)
    );
  achievements
    .filter(achievement => achievement.tier !== null)
    .slice(6, 12)
    .forEach(achievement =>
      bottomBadges.push(
        <Achievement {...achievement} tier={achievement.tier!} />
      )
    );
  while (topBadges.length < 6) topBadges.push(<EmptyBadge />);
  while (bottomBadges.length < 6) bottomBadges.push(<EmptyBadge />);

  return (
    <div className={styles.achievementCardContainer}>
      <span className={styles.title}>Achievements</span>
      <span className={styles.subTitle}>
        Complete challenges to receive badges and awards
      </span>
      <div className={styles.badgeRow}>{topBadges.map(badge => badge)}</div>
      <div className={styles.badgeRow}>{bottomBadges.map(badge => badge)}</div>
    </div>
  );
};
